import { Alert } from "reactstrap";

export const GridLoadingOverlay = () => {
  return (
    <div role="presentation" className="custom-loading-overlay">
      <Alert aria-live="polite" aria-atomic="true" color="info">
        Loading initial data...
      </Alert>
    </div>
  );
};
